import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const newRelic = defineConnector({
  identifier: "newRelic",
  name: "New Relic",
  tagLine: "Observability and monitoring",
  logo,
  protocol: "http",
  tags: ["observability", "data"],
  defaultUrlPattern: () => "https://api\\.newrelic\\.com/.*",
  auth: (app) => headerAuth([{ name: "Api-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [New Relic API keys](https://one.newrelic.com/launcher/api-keys-ui.api-keys-launcher) to create or view your API keys. You will need a User key for API access.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "New Relic API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.newrelic.com/graphql",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: "{ actor { user { id } } }" }),
    }),
  },
});
